import { ChartData, ChartOptions } from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { RegionDistribution } from '../../../../../../../api/theHive/redeProto/types';
import { protoColors } from '../../../theme/tokens';
import '../register';

interface RegionChartProps {
  data: RegionDistribution[];
  height?: number;
}

export function RegionChart({
  data,
  height = 260,
}: RegionChartProps): JSX.Element {
  const chartData: ChartData<'bar'> = {
    labels: data.map((item) => item.region),
    datasets: [
      {
        label: 'Meta',
        data: data.map((item) => item.goal),
        backgroundColor: `${protoColors.textMuted}55`,
        borderRadius: 6,
      },
      {
        label: 'Credenciados',
        data: data.map((item) => item.accredited),
        backgroundColor: protoColors.purple,
        borderRadius: 6,
      },
    ],
  };

  const options: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom', labels: { usePointStyle: true } },
    },
    scales: {
      y: { beginAtZero: true, grid: { color: '#EEEEF2' } },
      x: { grid: { display: false } },
    },
  };

  return (
    <div style={{ height }}>
      <Bar data={chartData} options={options} />
    </div>
  );
}
